'use client'

import { useEffect } from 'react'

import { useSession } from 'next-auth/react'

import { provideSession } from '@/lib/clients/getCachedSession'

export const SessionProviderSync = () => {
  const { data: session, status } = useSession()

  useEffect(() => {
    if (status === 'loading') {
      return
    }

    provideSession(session ?? null)
  }, [session, status])

  return null
}
